import { render, staticRenderFns } from "./VoucherChangeLogs.vue?vue&type=template&id=08fefb20&"
import script from "./VoucherChangeLogs.vue?vue&type=script&lang=js&"
export * from "./VoucherChangeLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports